module.exports = __webpack_public_path__ + "assets/img/face_crux_describe.5db0e44d.png";